export const duration = 6000;
export const NOTIFICATION_CLICK_REASON = {
    CLICKAWAY: 'clickaway'
};
